<button
  [matButton]="type"
  [disabled]="loading||disabled"
  (click)="onClick.emit()"
>
  @if (loading) {
  <mat-spinner [diameter]="28"></mat-spinner>
  }@else{
  <ng-content></ng-content>
  }
</button>
